import * as React from "react";
import { Filter } from "lucide-react";

import { IconButton } from "./icon-button";

/**
 * Thin wrapper over `IconButton`, kept for API compatibility (spec §5.21).
 * The active state is a neutral `bg-selected` wash — never a brand fill.
 */
export interface ToolbarFilterButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

const ToolbarFilterButton = React.forwardRef<
  HTMLButtonElement,
  ToolbarFilterButtonProps
>(({ active = false, className, title = "Filter", ...rest }, ref) => (
  <IconButton
    ref={ref}
    size="sm"
    active={active}
    label={title}
    className={className}
    {...rest}
  >
    <Filter aria-hidden="true" />
  </IconButton>
));
ToolbarFilterButton.displayName = "ToolbarFilterButton";

export { ToolbarFilterButton };
